"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jenkins_hash_lookup3_1 = require("jenkins-hash-lookup3");
const kshingles_1 = require("./util/kshingles");
const defaultSimhashOptions = {
    hashType: 'hashlittle',
    kshinglesN: 3
};
function simhash(s, options = {}) {
    options = Object.assign({}, defaultSimhashOptions, options);
    const { hashType, kshinglesN } = options;
    let hashFn;
    if (hashType === 'hashlittle') {
        hashFn = jenkins_hash_lookup3_1.hashlittle;
    }
    else if (hashType === 'hashword') {
        hashFn = jenkins_hash_lookup3_1.hashword;
    }
    const tokens = kshingles_1.default(s, kshinglesN);
    const hashs = tokens.map((token) => hashFn(token).c);
    let sim = 0;
    const mask = 1;
    for (let i = 0; i < 32; i++) {
        let w = 0;
        hashs.forEach((hash) => {
            w += (hash >>> i & mask) === 1 ? 1 : -1;
        });
        if (w > 0) {
            sim = sim | (mask << i);
        }
    }
    return sim >>> 0;
}
exports.simhash = simhash;
function hammingWeight(x) {
    let c = 0;
    for (; x; c++) {
        x &= (x - 1);
    }
    return c;
}
exports.hammingWeight = hammingWeight;
exports.hammingDistance = (x, y) => hammingWeight(x ^ y);
function similarity(x, y, options = {}) {
    const hashx = simhash(x, options);
    const hashy = simhash(y, options);
    return {
        score: hammingWeight(hashx & hashy) / hammingWeight(hashx | hashy),
        hammingDistance: exports.hammingDistance(hashx, hashy)
    };
}
exports.similarity = similarity;
//# sourceMappingURL=simhash.js.map